import { cn } from '@theprintbar/shared';
import { HTMLAttributes } from 'react';

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
	pattern?: string;
	children?: React.ReactNode;
}

export function Container({ className, pattern, ...props }: ContainerProps) {
	const child = <div className={cn('flex-1 mx-auto px-4 lg:px-8', className)} {...props} />;

	return pattern ? (
		<div className="flex-1" style={{ backgroundImage: `url(${pattern})` }}>
			{child}
		</div>
	) : (
		child
	);
}
